
import React from 'react';

// Components

import Tooltip from '../../common/tooltip/Tooltip';

// Constants

import { configs } from '../../../constants/configs/configs';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';


const ImmigrationStatusTooltip = props => {

    const {
        isState
    } = props;
    const { exchangeName } = useAppSelector(environmentSelector);

    return (
        <Tooltip
            { ...{
                id: 'ssap.start.get_ready.item.floater_anchor',
                linkDomId: 'immigration_status',
                dataAutomationId: 'immigration_status',
                content: 'ssap.start.get_ready.item.floater_content',
                href: isState.NV ? configs.externalEndpoints.NV_LINKS.IMMIGRATION_STATUS_LINK : null,
                index: 'immigration_status',
                triggerDecorationClassName: isState.NV ? 'border-none' : 'tooltip-base',
                replacement: { exchangeName },
                contentReplacement: { exchangeName },
            }  }
        />
    );
};

export default ImmigrationStatusTooltip;
